const regex = {
  PASSWORD: /^(?=.*[0-9!@#$%^&*)(+=._-])(?=.*[a-z])(?=.*[A-Z])(?!.*(.)\1).{8,50}/,
  CHAR_REGEX: /^(?=.*[a-z])(?=.*[A-Z])/,
  NUM_SPECIAL_REGEX: /^(?=.*[0-9])(?=.*[!@?#$%^&*])[a-zA-Z0-9!@#$%^&*]/,
  NO_MORE_TWICE:  /^(?!.*([A-Za-z0-9!@#$?&+,:;=_[\]#|{}'<>.^*()%-/])\1{2})/,
  RANGE:/^.{8,20}$/,
  DO_NOT_INCLUDE:/[$&+,:;=_[\]#|{}'<>.^*()%-/]/,
  EMAIL:/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  SECURITY_CODE: /^.{8,}$/,
  PHONE: /^(\+\d{1,3}[- ]?)?\d{10}$/
};
export default regex;
  